import { FleetFocusListItem } from '@models/successStory';
import { LanguageEntityAdminApiService } from './languageEntityAdminApiService';

export class ListItemAdminService extends LanguageEntityAdminApiService<FleetFocusListItem> {
    constructor() {
        super('/api/admin/listitem');
    }
}
